export default __webpack_public_path__ + "static/media/417.e3efcdb3.png";